module.exports = __webpack_public_path__ + "img/bca-light.f1485787.png";